import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "../ui/sidebar";
import { NavGroup } from "./nav-group";
import { NavUser } from "./nav-user";
import { TeamSwitcher } from "./team-switcher";
import type { AdminIdentity, AdminNavGroup, AdminWorkspace } from "./types";

type AppSidebarProps = Readonly<{
  groups: readonly AdminNavGroup[];
  user: AdminIdentity;
  workspace: AdminWorkspace;
  onNavigate: (destination: string) => void;
  onSignOut: () => void;
}>;

export function AppSidebar({
  groups,
  user,
  workspace,
  onNavigate,
  onSignOut,
}: AppSidebarProps) {
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <TeamSwitcher workspace={workspace} />
      </SidebarHeader>
      <SidebarContent>
        {groups.map((group) => (
          <NavGroup key={group.title} {...group} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} onNavigate={onNavigate} onSignOut={onSignOut} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
